import { FC } from 'react';

import styled from 'styled-components';
import Input from 'antd/es/input';

import CustomIcon from '@components/utils/CustomIcon';
import { Calendar2Line } from '@assets/icons';
import { FlexibleDiv } from '@components/formStyles';
import { SearchBarInputStyles } from '@shared/searchBar/styled';

type PropsType = {
  label: string;
  rightBorder?: boolean;
  onClick?(): void;
};

const StyledInput = styled(Input)`
  &&& {
    width: 100%;
    height: 56px;
    border-radius: 4px;
    ${SearchBarInputStyles};

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
    }
  }
`;

const EmptyComp: FC<PropsType> = ({ label }) => {
  return (
    <StyledInput
      className='date-input-component'
      readOnly
      placeholder={label}
      style={{ cursor: 'pointer' }}
      prefix={
        <FlexibleDiv right={4}>
          <CustomIcon
            fontSize={18}
            icon={Calendar2Line}
            paletteColor='grey500'
          />
        </FlexibleDiv>
      }
    />
  );
};

export default EmptyComp;
